module.exports = __webpack_public_path__ + "cefcb3389c28757b54ed65f7c8b8e5c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/White2.jpg
// module id = 8
// module chunks = 0